import jQuery from 'jquery';

jQuery(document).ready(function($) {
	
	/**
	 * Generic APM Table Init
	 *
	 * Standard dataTables initialization for tables used in most Academic
	 * Program Manager templates.
	 * 
	 * NOTE: original file - ../themes/ElonUniversity-Academic/assets/js/program-tables.js
	 */
	new DataTable('.elon-apm--data-table', {
		paging: false,
		responsive: true,
		columnDefs: [{
			"targets"  : 'no-sort',
			"orderable": false,
		}],
		layout: {
			top: {
				rowClass: 'elon-apm--data-filters data-filters--basic',
				className: 'data-filters--inner',
				features: 'search'
			},
			topStart: null,
			topEnd: null,
			bottomStart: null,
			bottomEnd: null
		},
		rowCallback: apmRowCallback
	});
	
	/**
	 * Advanced Programs Table Init
	 *
	 * Advanced dataTables initialization for the table used in the 
	 * "Elon APM - Programs Table Page (Advanced)" template.
	 * 
	 * NOTE: original file - ../themes/ElonUniversity-Core/assets/js/projects/academic-programs-table.js
	 */
	const $advTableEl = $('#elonApmAdvProgramsTable');
	 
	if ($advTableEl.length) {
		const $loaderEl = $('#elonApmTableLoader');
		const $searchInput = $('#elonApmProgramFiltersSearch');
		const $searchClear = $('#elonApmProgramFiltersSearchClear');
		const $typeFilter = $('#elonApmProgramTypeFilter');
		const $schoolFilter = $('#elonApmSchoolFilter');
		
		// Clear out search input on page refresh
		$searchInput.val('');
		
		// Clear select inputs on refresh
		$typeFilter.val(null).trigger('change');
		$schoolFilter.val(null).trigger('change');
		
		const advTable = new DataTable($advTableEl[0], {
			paging: false,
			responsive: {
				details: {
					type: 'column',
					target: 'button.details-control'
				}
			},
			order: [[ 0, "asc" ]],
			layout: {
				top: {
					rowClass: 'table-top',
					features: 'info'
				},
				topStart: null,
				topEnd: null,
				bottomStart: null,
				bottomEnd: null
			},
			columnDefs: [
				{
					orderable: false,
					targets: -1,
					createdCell: function (td, cellData, rowData, row, col) {
					  $(td).find('button.details-control').attr('aria-controls', 'dt-row-' + row + '-child')
					}
				},
				{ 
					orderable: false,
					targets: 'no-sort'
				}
			],
			language: {
				"info": '<strong>_END_</strong> Programs Match Your Selection',
				"infoFiltered": '',
				"infoEmpty": '<strong>0</strong> Programs Match Your Selection',
				"zeroRecords": 'No programs match your search.'
			},
			initComplete: function () {
				const api = this.api();
				
				$loaderEl.hide();
				$advTableEl.removeClass('loading');
				
				const typeColumn = api.column(1);
				const schoolColumn = api.column(4);
				
				$typeFilter.on('change', function () {
					typeColumn.search(this.value || '', false, false, false).draw();
				});
				
				$schoolFilter.on('change', function () {
					schoolColumn.search(this.value || '', false, false, false).draw();
				});
				
				$searchInput.on('input', function () {
					api.columns(0).search(this.value || '').draw();
				});
				
				$searchClear.on('click', function () {
					$searchInput.val('');
					api.columns(0).search('').draw();
				});
			},
			rowCallback: apmRowCallback
		});
		
		$advTableEl.find('tbody').on('click', 'button.details-control', function () {
			toggleDetailsRow(this, advTable);
		});
		
		// init select2 on table filters
		const baseSelect2Options = {
			minimumResultsForSearch: Infinity,
			allowClear: true
		};
		
		$typeFilter.select2({
			...baseSelect2Options,
			sorter: function(data) {
				// Custom sorter to place the "undergraduate major/minor" items first in the select list.
				// Other items are alphabetized after them.
				return data.sort(function(a, b) {
					const aText = a.text.toLowerCase();
					const bText = b.text.toLowerCase();
				
					const aStartsWithU = aText.startsWith('undergraduate');
					const bStartsWithU = bText.startsWith('undergraduate');
				
					if (aStartsWithU && !bStartsWithU) return -1;
					if (!aStartsWithU && bStartsWithU) return 1;
				
					return aText.localeCompare(bText, 'en', { sensitivity: 'base' });
				});
			}
		});
		
		$schoolFilter.select2(baseSelect2Options);
	}
	
	/**
	 * Programs List by Type Functionality
	 *
	 * jQuery functionality for managing an accordion interface with search filtering and accessibility enhancements.
	 */
	if ($('#elonApmProgramsList').length) {
		
		// Get necessary elements from the DOM
		var $accordion = $('#elonApmAccordion');
		var $headers = $accordion.find('.elon-apm--accordion-header');
		var $contentPanes = $accordion.find('div.elon-apm--accordion-content');
		var $searchInput = $('#elonApmSearchInput');
		var $searchClear = $('#elonApmClearSearch');
		var $noResultsMessage = $('#noResultsMessage');
		
		// Clear out search input on page refresh
		$searchInput.val('');
		
		/**
		 * Address some accessibility issues with jQuery UI accordions
		 * 
		 * - 1. Override jQuery UI setting negative tab index on accordion headers
		 * - 2. Assign appropriate aria attributes on accordion header click
		 */
		 
		// 1. Override jQuery UI setting negative tab index on accordion headers
		$headers.attr('tabindex', 0);
		
		// 2. Handle click event on accordion headers
		$headers.on('click', function() {
			var $header = $(this);
			var $content = $header.next('.elon-apm--accordion-content');
			var expanded = $header.attr('aria-expanded') === 'true';
			
			// Toggle aria-expanded/hidden attributes
			$header.attr('aria-expanded', !expanded);
			$content.attr('aria-hidden', expanded);
		});
		
		// Array to store the indexes of open accordions
		var openAccordionIndexes = [];
		
		// Check each header for the "open" state attribute on initial page load
		$headers.each(function(index) {
			if ($(this).attr('data-state') === 'open') {
				openAccordionIndexes.push(index);
			}
		});
		
		// Attach a click event handler to accordion headers
		$headers.on('click', function(event) {
			// Check if the event was triggered by the user (not programmatically)
			if (event.originalEvent) {
				// Get the index of the clicked header
				var index = $headers.index(this);
				// Get the current state of the clicked header
				var currentState = $(this).attr('data-state');
				
				// Update the openAccordionIndexes array based on the header state
				if (currentState === 'open') {
					// Remove the index if the a header click will close the pane
					openAccordionIndexes = openAccordionIndexes.filter(function(item) {
						return item !== index;
					});
				} else {
					// Add the index if the a header click will open the pane
					openAccordionIndexes.push(index);
				}
				
				// Update the state attribute
				var newState = currentState === 'closed' ? 'open' : 'closed';
				$(this).attr('data-state', newState);
				
			}
			
		});
		
		// Debounce the input event handler
		var debounceInputHandler = debounce(function(searchTerm) {
			
			if (searchTerm.trim() !== '') {
				// Show the search clear when input has a value
				$searchClear.show();
				
				// Expand all closed accordion panes once a search is initiated
				expandClosedAccordionPanes($headers, $accordion);
				
				// Filter the accordion content based on search terms
				filterAccordionContent($contentPanes, searchTerm, $accordion, $noResultsMessage);
			} else {
				// Trigger click on the clear search button
				$searchClear.trigger('click');
				
				// Hide the search clear when input is empty
				$searchClear.hide();
			}
			
		}, 300);
		
		// Bind the debounced input event handler to the search input field
		$searchInput.on('input', function() {
			// Grab the search term
			var searchTerm = $(this).val().trim().toLowerCase();
			
			// Fire the debounced input event handler
			debounceInputHandler(searchTerm);
		});
		
		// Bind the keydown event handler to the search input field
		$searchInput.on('keydown', function(event) {
			// Check if the Enter key is pressed
			if (event.keyCode === 13) {
				// Prevent the default behavior (page reload)
				event.preventDefault();
				
				// Remove the search input focus (this *should* hide virtual keyboards on touch devices on return press)
				$(this).filter(':input:focus').blur();
				
				// Calculate a scroll offset
				
				// Account for WP Admin bar if logged in
				var wpAdminBar = parseInt($('html').css('margin-top'), 10);
				
				// Set default scroll offset value
				var scrollOffset = wpAdminBar - 1; 
				
				// Account for sticky headers (on desktop)
				var $siteHeader = $('#headerArea');
				if ($siteHeader.length && $siteHeader.hasClass('headroom') && $(window).width() >= 1080) {
					var headerTopHeight = $siteHeader.find('.site-header--top').outerHeight();
					var headerBottomHeight = $siteHeader.find('.site-header--bottom').outerHeight();
					
					scrollOffset = scrollOffset + headerTopHeight + headerBottomHeight; 
				}
				
				// Scroll to the top of the programs list div
				var $targetElement = $('#elonApmProgramsList');
				if ($targetElement.length) {
					$('html, body').animate({
						scrollTop: $targetElement.offset().top - scrollOffset // the - 1 accounts for the 1px border on top of the list container
					}, 500);
				}
			}
		});
		
		// Clear search input
		$searchClear.on('click', function() {
			// Clear the input and focus on it
			$searchInput.val('').focus();
			
			// Hide the clear button
			$(this).hide();
			
			// Call the filter function to reset the search results
			filterAccordionContent($contentPanes, '', $accordion, $noResultsMessage);
			
			// Hide accordion panes that were not previously opened
			$headers.each(function(index) {
				// Check if the header is not in the "open" list. If it's not, it needs to be closed.
				if (!openAccordionIndexes.includes(index)) {
					// If it's currently open, trigger a click on the header.
					// This will close the content pane and toggle appropriate jQuery UI classes.
					// But it's important not to trigger a click on a header that may already
					// be closed because it could end up open again.
					if ($(this).attr('data-state') === 'open') {
						$(this).trigger('click');
					}
					// Regardless of current state, make sure header has appropriate aria attributes for "closed" state
					$(this).attr('aria-expanded', 'false').attr('data-state', 'closed');
					// Regardless of current state, make sure content has appropriate aria attributes for "closed" state
					// and the content pane is hidden.
					$(this).next('.elon-apm--accordion-content').attr('aria-hidden', 'true').hide();
				}
			});
		});
	}
	
});

/**
 * Applies odd/even row classes to visible rows in a DataTables instance.
 *
 * This function is used as the `rowCallback` option in DataTables, allowing you
 * to apply alternating row classes based on visibility and the row's display index.
 *
 * @param {HTMLTableRowElement} row - The row element in the table.
 * @param {Array} data - The data for the current row.
 * @param {number} displayIndex - The index of the row in the current page (after paging).
 * @returns {void}
 */
const apmRowCallback = (row, data, displayIndex) => {
	row.classList.remove('odd', 'even');

	if (!row.classList.contains('child')) {
		row.classList.add(displayIndex % 2 === 0 ? 'odd' : 'even');
	}
};

/**
 * Toggles the details row for a given table row in a DataTable.
 *
 * This function shows or hides the details for the clicked row in the table.
 * It also ensures that only one row can be expanded at a time by collapsing
 * other expanded rows. It modifies the row and button states accordingly.
 *
 * @param {HTMLButtonElement} btn - The button element used to toggle the row details.
 * @param {DataTable.Api} table - The DataTable instance.
 * @returns {void}
 */
const toggleDetailsRow = (btn, table) => {
	const $btn = $(btn);
	const $tr = $btn.closest('tr');
	const row = table.row($tr);

	if ($tr.hasClass('hide-details')) {
		table.rows().every(function () {
			const $otherTr = $(this.node());
			if ($otherTr.hasClass('parent')) {
				this.child.hide();
				$otherTr.removeClass('parent dtr-expanded').addClass('hide-details');
				$otherTr.find('button.details-control')
					.removeClass('details-open')
					.addClass('details-closed')
					.attr('aria-expanded', 'false');
			}
		});
		row.child.show();
		$tr.addClass('parent').removeClass('hide-details');
		$tr.next('tr.child').attr('id', 'dt-row-' + row.index() + '-child');
		$btn.addClass('details-open').removeClass('details-closed').attr('aria-expanded', 'true');
	} else {
		row.child.hide();
		$tr.removeClass('parent dtr-expanded').addClass('hide-details');
		$btn.removeClass('details-open').addClass('details-closed').attr('aria-expanded', 'false');
	}
};

/**
 * Returns a function, that, as long as it continues to be invoked, will not
 * be triggered. The function will be called after it stops being called for
 * N milliseconds.
 *
 * @param {Function} func - The function to debounce.
 * @param {number} wait - The number of milliseconds to wait before invoking the function.
 * @returns {Function} - The debounced function.
 */
function debounce(func, wait) {
	var timeout;
	return function() {
		var context = this,
			args = arguments;
		var later = function() {
			timeout = null;
			func.apply(context, args);
		};
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
	};
}

/**
 * Checks if any element in a jQuery collection contains a substring matching the search term.
 *
 * @param {jQuery} $elements - The jQuery collection of elements to search.
 * @param {string} searchTerm - The search term to match against.
 * @returns {boolean} True if any element in the collection contains a matching substring, otherwise false.
 */
function hasMatch($elements, searchTerm) {
	// Filter the jQuery collection of elements
	return $elements.filter(function() {
		// Get the text content of the element.
		var text = $(this).text().toLowerCase();
		
		// Remove the substring "(opens a new window)" if present.
		// This string is added to external links and we want to remove it
		// before comparing for a match so we don't get false positives
		// if someone searches for words within this string.
		text = text.replace(/\(opens a new window\)/g, '').trim();
		
		// Check if the modified text contains the search term.
		return text.indexOf(searchTerm.toLowerCase()) !== -1;
	}).length > 0;
}

/**
 * Expands all closed accordion panes by activating their associated headers.
 *
 * @param {jQuery} $headers - The jQuery collection of accordion headers.
 * @param {jQuery} $accordion - The jQuery object representing the accordion container.
 * @returns {void}
 */
function expandClosedAccordionPanes($headers, $accordion) {
	// Iterate over each accordion header
	$headers.each(function() {
		var $header = $(this);
		
		// Check if the header is in the closed state
		if ($header.attr('data-state') === 'closed') {
			// Trigger a click event on the header to open the associated accordion pane
			$header.trigger('click');
			
			// Update attributes to reflect the open state
			$header.attr('aria-expanded', 'true').attr('data-state', 'open');
			
			// Update attributes on the associated accordion content to reflect the open state
			$header.next('div.elon-apm--accordion-content').attr('aria-hidden', 'false');
		}
	});
}

/**
 * Filters list items within each unordered list based on the provided search term.
 * Hides or shows lists and their headers based on whether any list item matches the search term.
 *
 * @param {jQuery} $uls - The jQuery collection of unordered lists to filter.
 * @param {string} searchTerm - The search term to match against.
 * @returns {void}
 */
function filterListItems($uls, searchTerm) {
	// Iterate over each unordered list
	$uls.each(function() {
		var $ul = $(this);
		var $lis = $ul.find('li');
		// Check if any list item matches the search term
		var anyMatchInLis = hasMatch($lis, searchTerm);
		
		// Hide or show the unordered list and corresponding heading based on matching results
		if (!anyMatchInLis) {
			$ul.hide();
			$ul.prev('.accordion-content--header').hide();
		} else {
			$ul.show();
			$ul.prev('.accordion-content--header').show();
			
			// Iterate over each list item and show or hide based on matching results
			$lis.each(function() {
				var $li = $(this);
				if (!hasMatch($li, searchTerm)) {
					$li.hide();
				} else {
					$li.show();
				}
			});
		}
	});
}

/**
 * Filters accordion content based on the provided search term, showing or hiding content panes and headers accordingly.
 *
 * @param {jQuery} $contentPanes - The jQuery collection of accordion content panes to filter.
 * @param {string} searchTerm - The search term to match against.
 * @param {jQuery} $accordion - The jQuery object representing the accordion container.
 * @param {jQuery} $noResultsMessage - The jQuery object representing the message to display when no results are found.
 * @returns {void}
 */
function filterAccordionContent($contentPanes, searchTerm, $accordion, $noResultsMessage) {
	// Flag to track if any match is found in any content pane
	var anyMatchInAccordion = false;
	
	// Iterate over each content pane
	$contentPanes.each(function() {
		
		// Get references to the content pane, header, and unordered lists within the pane
		var $content = $(this);
		var $contentHeader = $content.prev('.elon-apm--accordion-header');
		var $uls = $content.find('ul');
		
		// Check if any list item in any list in the content pane matches the search term
		var anyMatchInULs = hasMatch($uls.find('li'), searchTerm);
		
		// No matches found anywhere in the content pane
		if (!anyMatchInULs) {
			// Hide the accordion header/content group
			$content.hide();
			$contentHeader.hide();
		} else {
			// Show the accordion header/content group
			$content.show();
			$contentHeader.show();
			// Set flag to true if any match is found
			anyMatchInAccordion = true;
			// Filter list items based on search term
			filterListItems($uls, searchTerm);
		}
		
	});
	
	// Display "no programs found" message if no programs are found
	if (!anyMatchInAccordion) {
		$noResultsMessage.show();
		$accordion.hide();
	} else {
		$noResultsMessage.hide();
		$accordion.show();
	}
}
